export { default } from './FirstEmailConfirmDefaultNoticeBlock';



// WEBPACK FOOTER //
// ./src/components/UserAccount/Confirms/ConfirmNoticeBlocks/FirstEmailConfirmNoticeBlock/index.js